<template>
  <div class="flv-box">
    <video ref="video" muted></video>
    <div class="play-button" @click="play" v-if="showPlayButton"></div>
  </div>
</template>
<script>
  import flvjs from 'flvjs'
  export default {
    props: {
      profile: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        showPlayButton: false,
        flvPlayer: null,
      }
    },
    methods: {
      play() {
        try {
          this.flvPlayer.play()
        } finally {
          if (this.$refs.video.paused) {
            this.showPlayButton = true
          } else {
            this.showPlayButton = false
          }
        }
      }
    },
    async mounted() {
      const videoEle = this.$refs.video
      this.flvPlayer = flvjs.createPlayer({
        type: 'flv',
        isLive: true,
        hasAudio: true,
        hasVideo: true,
        enableWorker: true,
        muted: false,
        url: this.profile.play_url
      })
      this.flvPlayer.attachMediaElement(videoEle)
      this.flvPlayer.load()
      this.flvPlayer.on(flvjs.Events.ERROR, () => {
        this.$emit('end')
      })
      this.flvPlayer.on(flvjs.Events.LOADING_COMPLETE, () => {
        this.$emit('end')
      })
      try {
        await this.flvPlayer.play()
      } catch(ignore) {
        this.showPlayButton = true
      } finally {
        this.flvPlayer.muted = false
        if (videoEle.paused) {
          this.showPlayButton = true
        }
      }
      window.flvPlayer = this.flvPlayer
    }
  }
</script>
<style lang="less" scoped>
@import "../css/flv.less";
</style>
